import React from "react";
import { NavLink } from "react-router-dom";

export default function TeacherSidebar() {
  const linkStyle = ({ isActive }) => ({
    display: "block",
    padding: "12px 14px",
    borderRadius: 10,
    textDecoration: "none",
    fontWeight: 700,
    color: isActive ? "#0f3b82" : "#374151",
    background: isActive ? "#eef3fb" : "transparent"
  });

  return (
    <div style={{ width: 260, padding: 16, borderRight: "1px solid var(--theme-border)", background: "#fff" }}>
      <div style={{ fontWeight: 900, fontSize: 16, color: "#111827", marginBottom: 10 }}>Teacher Portal</div>
      <nav style={{ display: "grid", gap: 8 }}>
        <NavLink to="/teacher/dashboard" style={linkStyle}>Dashboard</NavLink>
        <NavLink to="/teacher/attendance" style={linkStyle}>Attendance</NavLink>
        <NavLink to="/teacher/classes" style={linkStyle}>Class Program</NavLink>
        <NavLink to="/teacher/gradebooks" style={linkStyle}>Gradebooks</NavLink>
        <NavLink to="/teacher/calendar" style={linkStyle}>School Calendar</NavLink>
      </nav>
    </div>
  );
}
